export const GET_CONFIGURATION = 'GET_CONFIGURATION'
export const GET_CONFIGURATION_EXITO = 'GET_CONFIGURATION_EXITO'
export const GET_CONFIGURATION_ERRROR = 'GET_CONFIGURATION_ERROR'
